import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import Styles from "./Login.module.css";

const LoginSchema = Yup.object().shape({
	email: Yup.string()
		.email("Invalid email")
		.required("Required"),
	password: Yup.string().required("Required"),
});

const LoginCompo = () => {
	const [showPassword, setShowPassword] = useState(false);
	return (
		<div className={Styles.container}>

			<div className={Styles.formikContainer}>
			<h1 className={Styles.h1}>Login</h1>
				<Formik
					initialValues={{
						email: "",
						password: "",
					}}
					validationSchema={LoginSchema}
					onSubmit={(values, actions) => {
						console.log(values);
						actions.setSubmitting(true);
					}}
				>
					{({ values, handleChange }) => (
						<Form>
							<div>
								<label
									htmlFor='email'
									className={Styles.label}
								>
									Email
								</label>
								<Field
									id='email'
									type='email'
									name='email'
									value={values.email}
									onChange={handleChange}
									className={Styles.input}
								/>

								<ErrorMessage
									name='email'
									component='div'
								/>
							</div>
							<label
								htmlFor='password'
								className={Styles.label}
							>
								Password
							</label>
							<div
								style={{
									position: "relative",
								}}
							>
								<Field
									id='password'
									name='password'
									value={values.password}
									onChange={handleChange}
									className={Styles.input}
									type={showPassword ? "text" : "password"}
								/>
								{showPassword ? (
									<VisibilityOffIcon
										className={
											Styles.passwordVisibilityIcon
										}
										onClick={() => setShowPassword(false)}
										title='Hide'
									/>
								) : (
									<VisibilityIcon
										className={
											Styles.passwordVisibilityIcon
										}
										onClick={() => setShowPassword(true)}
										title='Show'
									/>
								)}
							</div>
							<ErrorMessage
								name='password'
								component='div'
							/>

							<button
								type='submit'
								className={Styles.btn}
							>
								Login
							</button>
						</Form>
					)}
				</Formik>
			</div>
		</div>
	);
};

export default LoginCompo;
